import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Modal, Button, Row } from 'antd';
import isMobile from '../../utils/isMobile';
const defaultProps = {
    title: 'Are you sure you want to exit your wallet?',
    subTitle: [
        'Your current wallet and assets will be removed from this app permanently. This action cannot be undone.',
        'You can ONLY recover this wallet with your guardians.',
    ],
    okTxt: 'I Understand，Confirm Exit',
    cancelTxt: 'Cancel',
    visible: false,
    onOk: () => void 0,
    onCancel: () => void 0,
    width: 430,
    mobileWidth: 343,
};
export default function ConfirmLogoutDialog(props) {
    const { title, subTitle, okTxt, cancelTxt, visible, onOk, onCancel, width, mobileWidth } = {
        ...defaultProps,
        ...props,
    };
    const isMobileDevice = isMobile();
    const renderContent = useMemo(() => subTitle?.map((t) => (_jsx(Row, { className: "aelf-web-logout-dialog-sub-title", children: t }, t))), [subTitle]);
    const bodyStyle = useMemo(() => ({
        borderRadius: isMobileDevice ? '8px' : '6px',
        padding: '0',
    }), [isMobileDevice]);
    return (_jsx(Modal, { footer: null, title: null, open: visible, width: isMobileDevice ? mobileWidth : width, bodyStyle: bodyStyle, closable: false, children: _jsxs(Row, { className: "aelf-web-logout-dialog", children: [_jsxs(Row, { className: `aelf-web-logout-dialog-content ${isMobileDevice && 'aelf-web-logout-dialog-content-mobile'}`, children: [_jsx(Row, { className: "aelf-web-logout-dialog-close", onClick: onCancel, children: _jsx("i", {}) }), _jsx(Row, { className: "aelf-web-logout-dialog-title", children: title }), renderContent] }), _jsxs(Row, { className: `aelf-web-logout-dialog-content ${isMobileDevice && 'aelf-web-logout-dialog-content-mobile'}`, children: [_jsx(Button, { className: "aelf-web-logout-dialog-btn ok-btn", onClick: onOk, children: okTxt }), _jsx(Button, { className: "aelf-web-logout-dialog-btn cancel-btn", onClick: onCancel, children: cancelTxt })] })] }) }));
}
